module.exports = __webpack_public_path__ + "829563588c4fcc023da8b035fe8ced1e.svg";